import axios from 'axios'
import Cookies from 'js-cookie'

const api = axios.create({
    headers: {
        common: {
            Accept: 'text/plain, */*',
        },
        'Content-Type': 'application/json',
    },
    baseURL: import.meta.env.PUBLIC_API_URL,
})

api.interceptors.request.use(function (config) {
    const token = Cookies.get('ml-token');
    config.headers.Authorization = token ? `Bearer ${token}` : config.headers?.Authorization;
    return config;
});

export default api;
